import { HotelResultPackagesPayload } from '@packages/packages-result/entities/hotel-results';
import { AirResultOptionResponse } from '@packages/packages-result/entities/air-results';
import { HotelResultsState } from '@packages/packages-result/store/reducers/hotel-results.reducer';
import { PackageSeachResponse } from '@packages/packages-result/entities/packages-search';
import { FlightResultsPackageState } from '@packages/packages-result/store/reducers/flight-results.reducer';
import { HotelSearched } from '@hotels/hotel-results/entities/hotel-searched';
import { FlightResultDesktop } from '@app/entities/flight-results';
import { AirResultPackagesPayload } from '@packages/packages-result/entities/air-results';
import { HotelAmenity } from '@hotels/hotel-results/entities/hotel-filters.response';
import { FlightWidgetsMobile } from '@app/entities/flight-results-widget';
import { ZoneResponse } from '@app/entities/zones.response';
import { ShowedPackageDetailsFlightsState } from '@packages/packages-result/store/reducers/ui/showed-details.reducer';

export const packageResulFeatureName = 'packageResultModuleState';

export type UIPackagesResultState = Readonly<{
  hotelRoomRateId: string,
  isLoadingAirOption: boolean,
  isLoadingMarkers: boolean,
  isLoadingHotelFilters: boolean,
  isLoadingAirFilters: boolean,
  disabledInfinityScroll: boolean,
  showedPackageDetails: ShowedPackageDetailsFlightsState,
  sortFilterHasBeenChanged: boolean;
  hotelMapView: boolean;
}>;

export type PackageResultModuleState = Readonly<{
  ui: UIPackagesResultState,
  airResultSelected: AirResultOptionResponse,
  hotelResults: HotelResultsState,
  packageSearchData: PackageSeachResponse,
  flightResults: FlightResultsPackageState,
  hotelResultSelected: HotelSearched,
  flightResultsDesktop: FlightResultDesktop[],
  airResultSelectedDesktop: FlightResultDesktop,
  hotelsPayload: HotelResultPackagesPayload,
  flightsPayload: AirResultPackagesPayload,
  packageHotelAmenities: HotelAmenity[],
  packageAirWidgets: FlightWidgetsMobile,
  packageHotelTopZones: ZoneResponse[],
  hotelMarkers: HotelResultsState,
  packageHotelDetailSearched: HotelSearched
}>;
